import { useState } from "react";

import { useGetActivities } from "~/v2/api/hooks";
import { useAccountContext } from "~/v2/providers/AccountProvider";
import { isoDaysAgo } from "./overviewActivities.utils";
import { useRecentActivityCardController } from "./RecentActivityCard.controller";
import { RecentActivityCardPresentation } from "./RecentActivityCard.pres";
import { useReservedRowsHeight } from "./useReservedRowsHeight";

const LOOKBACK_DAYS = 30;

export const RecentActivityCard = () => {
  const { currentAccount, product } = useAccountContext();
  const accountID = currentAccount?.id;
  const isAccountReady = Boolean(accountID && product);

  // Anchored once per mount so the request key stays stable across renders.
  const [after] = useState(() => isoDaysAgo(LOOKBACK_DAYS));

  const { activities, isLoading, isError } = useGetActivities(
    {
      accountID: accountID ?? "",
      paper: product === "paper",
      after,
    },
    { enabled: isAccountReady },
  );

  const controller = useRecentActivityCardController({
    activities,
    isAccountReady,
    isLoading: isAccountReady && isLoading,
    hasError: isError,
  });
  const { headerRowRef, probeRowRef, headerHeight, reservedHeight } =
    useReservedRowsHeight(controller.rowLimit);

  return (
    <RecentActivityCardPresentation
      rows={controller.rows}
      totalCount={controller.totalCount}
      filter={controller.filter}
      onFilterChange={controller.onFilterChange}
      rowLimit={controller.rowLimit}
      emptyMessage={controller.emptyMessage}
      headerRowRef={headerRowRef}
      probeRowRef={probeRowRef}
      headerHeight={headerHeight}
      reservedHeight={reservedHeight}
      hasError={isError}
    />
  );
};
